import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceFiscalAssessmentSimpleEntriesAdvanceProps {
  fiscalAssessmentEntryId: string;
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceFiscalAssessmentSimpleEntriesAdvance = ({
  fiscalAssessmentEntryId,
  options,
}: UseMaintenanceFiscalAssessmentSimpleEntriesAdvanceProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceFiscalAssessmentSimpleEntriesAdvance'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/fiscal_assessment/simple_entries/${fiscalAssessmentEntryId}/advance`);
    },
    ...options
  });
}
